import Entity from './entity'
import QuestionTplDetValue from './questiontpldetvalue'
export default class QuestionTplDet extends Entity<number>{
	id:number;
    name:string;	
	questionValueType:number;
	sort:number;
	isMust:number;
	detTpl:string;
	answer:string;
	answerParse:string;
	status:string;
	content:string;
	contentlist:Array<object>;
	questionTplDetValueList:Array<QuestionTplDetValue>;
}